import { atom } from 'jotai';

export const showDrawerAtom = atom(false);
